import React, { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { HvGrid, HvTypography } from "@hitachivantara/uikit-react-core";

import SubCategoryTable from "components/incidentType/SubCategoryTable";
import Container from "components/layout/Container";
import { ModuleNames, ModulePolicyTypes } from "lib/api/userSettings";
import { UserDataContext } from "lib/context/UserDataContext";
import NotFound from "components/common/NotFound";

const Subcategory: React.FC = () => {
  const { t } = useTranslation("incidentTypeSubCategory");

  return (
    <Container>
      <HvGrid container>
        <HvGrid item xs={12}>
          <HvTypography variant="mTitle" component="h1">
            {t("title")}
          </HvTypography>
        </HvGrid>
        <HvGrid item xs={12}>
          <SubCategoryTable />
        </HvGrid>
      </HvGrid>
    </Container>
  );
};
export const SubcategoryAuth: React.FC = () => {
  const { hasModulePolicy } = useContext(UserDataContext);
  const hasRight = useMemo(() => {
    return hasModulePolicy(
      ModuleNames.incidentManagement,
      ModulePolicyTypes.incident
    );
  }, [hasModulePolicy]);
  return <>{hasRight ? <Subcategory /> : <NotFound />}</>;
};
export default Subcategory;
